import React from 'react';

/**
 * props:
 * - eyebrow
 * - title
 * - subtitle
 * - actions
 */
export function PageHeader({ eyebrow, title, subtitle, actions }) {
    return (
        <header className="private-page-header">
            <div className="private-page-header-main">
                {eyebrow ? <span className="private-page-eyebrow">{eyebrow}</span> : null}
                <h1 className="private-page-title">{title}</h1>
                {subtitle ? <p className="private-page-subtitle">{subtitle}</p> : null}
            </div>
            {actions ? (
                <div className="private-page-header-actions">
                    {actions}
                </div>
            ) : null}
        </header>
    );
}

export default PageHeader;